import { createGlobalStyle } from "styled-components";

const globalStyle = createGlobalStyle`
  body, button, input, select, textarea {
    font-family: 'Nunito Sans', sans-serif;
  }
`;

export default globalStyle;
